import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { formatText } from "@ui/format";
import { Button, List } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export interface StepFields {}

interface Props extends AbstractStepProps {
	loanAmount: number;
	installmentMinAmount: number;
	installmentMaxAmount?: number;
	loanMax70mEntitled?: boolean;
	necesseryLoadAmount?: number;
	installmentWithoutCSOK?: number;
}

export class Result extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		const {
			loanAmount,
			installmentMinAmount,
			loanMax70mEntitled = false,
			necesseryLoadAmount = 0,
			installmentWithoutCSOK = 0,
		} = this.props;

		return (
			<>
				<Card.Header className="bg-secondary-gradient-lighter text-white text-center">
					<mark className="d-inline-block bg-white text-primary mt-2 display-6 px-2">
						<strong>{formatText(loanAmount, "ft")} hitel 25 évre</strong>
					</mark>

					{installmentWithoutCSOK > 0 ? (
						<div className="mt-2">
							<div className="result-title">CSOK hitellel:</div>
							<div className="h1 m-0">{formatText(installmentMinAmount, "ft")}/hó</div>
							<hr className="hr-gl" />
							<div className="result-title">CSOK hitel nélkül:</div>
							<div className="h1 m-0">{formatText(installmentWithoutCSOK, "ft")}/hó</div>
						</div>
					) : (
						this.renderInstallmentResult()
					)}
					<div className="pt-2 mb-2">törlesztőrészlettel érhető el számodra</div>
				</Card.Header>
				<Card.Body className="d-flex flex-column">
					{loanMax70mEntitled && (
						<p className="display-6 text-center mt-2 mb-3 pb-2 border-bottom-2">
							Még szükséges <strong>{formatText(necesseryLoadAmount, "ft")}</strong>, melyet piaci
							kölcsönből tudnál felvenni.
						</p>
					)}
					<div className="h5 text-center mt-2 mb-3">
						A részletes eredményeidet
						<br /> e-mailben küldjük el
					</div>
					<List itemStyle="tick" variant="primary">
						<List.Item>
							Megtudhatod <strong>mennyi zöldhitelt</strong> és csok-hitelt vehetnél fel
						</List.Item>
						<List.Item>
							Megismerheted a <strong>csok-hitel feltételeit</strong> részletesen
						</List.Item>
						<List.Item>
							<strong>Szakértőink segitenek</strong> bármilyen felmerülő kérdésben
						</List.Item>
					</List>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button type="submit" className="text-uppercase">
						Kérem az eredményeimet
					</Button>
				</Card.Footer>
			</>
		);
	}

	private renderInstallmentResult(): ReactNode {
		const { installmentMinAmount, installmentMaxAmount = 0 } = this.props;

		if (installmentMaxAmount > 0) {
			return (
				<div className="display-4 font-weight-bold mt-2">
					{`${formatText(installmentMinAmount, "ft")} - ${formatText(installmentMaxAmount, "ft")}`}
				</div>
			);
		}

		return <div className="display-2 mt-2 font-weight-bold mt-2">{formatText(installmentMinAmount, "ft")}</div>;
	}

	protected getComponentName(): string {
		return "Result";
	}
}
